<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.discount-selection.title'">
    <wbo-text-column field="name" [title]="'wbo.report.discount-selection.column.discountName'"></wbo-text-column>
    <!--wbo-text-column field="lastName" [title]="'wbo.report.employee-selection.column.lastName'"></wbo-text-column-->
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromDiscount([$event])">
            <wbo-discount-single-select-edit-control></wbo-discount-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="DiscountSearchPageComponent" (onSelect)="addFromDiscount($event)"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
